/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as ContactRouteImport } from './routes/contact'
import { Route as StudentRouteRouteImport } from './routes/student/route'
import { Route as PartnerRouteRouteImport } from './routes/partner/route'
import { Route as InstitutionRouteRouteImport } from './routes/institution/route'
import { Route as AdminRouteRouteImport } from './routes/admin/route'
import { Route as IndexRouteImport } from './routes/index'
import { Route as OnboardingIndexRouteImport } from './routes/onboarding/index'
import { Route as VerifyCodeRouteImport } from './routes/verify/$code'
import { Route as OnboardingStudentRouteImport } from './routes/onboarding/student'
import { Route as OnboardingPartnerRouteImport } from './routes/onboarding/partner'
import { Route as AuthLogin2faRouteImport } from './routes/auth/login-2fa'
import { Route as StudentWorkLogsIndexRouteImport } from './routes/student/work-logs/index'
import { Route as StudentWalletIndexRouteImport } from './routes/student/wallet/index'
import { Route as StudentVerificationIndexRouteImport } from './routes/student/verification/index'
import { Route as StudentTipsIndexRouteImport } from './routes/student/tips/index'
import { Route as StudentSupportIndexRouteImport } from './routes/student/support/index'
import { Route as StudentSimulatedIndexRouteImport } from './routes/student/simulated/index'
import { Route as StudentReportsIndexRouteImport } from './routes/student/reports/index'
import { Route as StudentProfileIndexRouteImport } from './routes/student/profile/index'
import { Route as StudentPlacementIndexRouteImport } from './routes/student/placement/index'
import { Route as StudentPaymentsIndexRouteImport } from './routes/student/payments/index'
import { Route as StudentNotificationsIndexRouteImport } from './routes/student/notifications/index'
import { Route as StudentDashboardIndexRouteImport } from './routes/student/dashboard/index'
import { Route as StudentCvIndexRouteImport } from './routes/student/cv/index'
import { Route as StudentCoursesIndexRouteImport } from './routes/student/courses/index'
import { Route as StudentCertificatesIndexRouteImport } from './routes/student/certificates/index'
import { Route as StudentBadgesIndexRouteImport } from './routes/student/badges/index'
import { Route as StudentAssessmentsIndexRouteImport } from './routes/student/assessments/index'
import { Route as PartnerWorkLogsIndexRouteImport } from './routes/partner/work-logs/index'
import { Route as PartnerVerificationIndexRouteImport } from './routes/partner/verification/index'
import { Route as PartnerTipsIndexRouteImport } from './routes/partner/tips/index'
import { Route as PartnerSupportIndexRouteImport } from './routes/partner/support/index'
import { Route as PartnerStudentsIndexRouteImport } from './routes/partner/students/index'
import { Route as PartnerSlotsIndexRouteImport } from './routes/partner/slots/index'
import { Route as PartnerRecommendationsIndexRouteImport } from './routes/partner/recommendations/index'
import { Route as PartnerProfileIndexRouteImport } from './routes/partner/profile/index'
import { Route as PartnerNotificationsIndexRouteImport } from './routes/partner/notifications/index'
import { Route as PartnerDashboardIndexRouteImport } from './routes/partner/dashboard/index'
import { Route as PartnerAssessmentsIndexRouteImport } from './routes/partner/assessments/index'
import { Route as InstitutionDashboardIndexRouteImport } from './routes/institution/dashboard/index'
import { Route as AuthResetPasswordIndexRouteImport } from './routes/auth/reset-password/index'
import { Route as AuthRegisterIndexRouteImport } from './routes/auth/register/index'
import { Route as AuthLoginIndexRouteImport } from './routes/auth/login/index'
import { Route as AuthForgotPasswordIndexRouteImport } from './routes/auth/forgot-password/index'
import { Route as AdminWorkLogsIndexRouteImport } from './routes/admin/work-logs/index'
import { Route as AdminVerificationsIndexRouteImport } from './routes/admin/verifications/index'
import { Route as AdminUsersIndexRouteImport } from './routes/admin/users/index'
import { Route as AdminTrashIndexRouteImport } from './routes/admin/trash/index'
import { Route as AdminTipsIndexRouteImport } from './routes/admin/tips/index'
import { Route as AdminStudentsIndexRouteImport } from './routes/admin/students/index'
import { Route as AdminSettingsIndexRouteImport } from './routes/admin/settings/index'
import { Route as AdminSessionsIndexRouteImport } from './routes/admin/sessions/index'
import { Route as AdminSeminarsIndexRouteImport } from './routes/admin/seminars/index'
import { Route as AdminReportsIndexRouteImport } from './routes/admin/reports/index'
import { Route as AdminPlacementsIndexRouteImport } from './routes/admin/placements/index'
import { Route as AdminPaymentsIndexRouteImport } from './routes/admin/payments/index'
import { Route as AdminPartnersIndexRouteImport } from './routes/admin/partners/index'
import { Route as AdminOnboardingIndexRouteImport } from './routes/admin/onboarding/index'
import { Route as AdminNotificationsIndexRouteImport } from './routes/admin/notifications/index'
import { Route as AdminLeaderboardIndexRouteImport } from './routes/admin/leaderboard/index'
import { Route as AdminInstitutionsIndexRouteImport } from './routes/admin/institutions/index'
import { Route as AdminHelpSupportIndexRouteImport } from './routes/admin/help-support/index'
import { Route as AdminFeedbackIndexRouteImport } from './routes/admin/feedback/index'
import { Route as AdminDashboardIndexRouteImport } from './routes/admin/dashboard/index'
import { Route as AdminCoursesIndexRouteImport } from './routes/admin/courses/index'
import { Route as AdminContentIndexRouteImport } from './routes/admin/content/index'
import { Route as AdminCertificatesIndexRouteImport } from './routes/admin/certificates/index'
import { Route as AdminBadgesIndexRouteImport } from './routes/admin/badges/index'
import { Route as AdminAuditLogsIndexRouteImport } from './routes/admin/audit-logs/index'
import { Route as StudentWorkLogsNewRouteImport } from './routes/student/work-logs/new'
import { Route as StudentWorkLogsIdRouteImport } from './routes/student/work-logs/$id'
import { Route as PartnerWorkLogsIdRouteImport } from './routes/partner/work-logs/$id'
import { Route as PartnerStudentsIdRouteImport } from './routes/partner/students/$id'
import { Route as PartnerSlotsNewRouteImport } from './routes/partner/slots/new'
import { Route as PartnerSlotsIdRouteImport } from './routes/partner/slots/$id'
import { Route as PartnerRecommendationsNewRouteImport } from './routes/partner/recommendations/new'
import { Route as AdminStudentsIdRouteImport } from './routes/admin/students/$id'
import { Route as AdminPlacementsAssignRouteImport } from './routes/admin/placements/assign'
import { Route as AdminPartnersIdRouteImport } from './routes/admin/partners/$id'
import { Route as AdminCoursesDiscoveryRouteImport } from './routes/admin/courses/discovery'
import { Route as StudentCoursesIdIndexRouteImport } from './routes/student/courses/$id/index'
import { Route as StudentWorkLogsEditIdRouteImport } from './routes/student/work-logs/edit/$id'
import { Route as StudentCoursesIdLearnRouteImport } from './routes/student/courses/$id/learn'

const ContactRoute = ContactRouteImport.update({
  id: '/contact',
  path: '/contact',
  getParentRoute: () => rootRouteImport,
} as any)
const StudentRouteRoute = StudentRouteRouteImport.update({
  id: '/student',
  path: '/student',
  getParentRoute: () => rootRouteImport,
} as any)
const PartnerRouteRoute = PartnerRouteRouteImport.update({
  id: '/partner',
  path: '/partner',
  getParentRoute: () => rootRouteImport,
} as any)
const InstitutionRouteRoute = InstitutionRouteRouteImport.update({
  id: '/institution',
  path: '/institution',
  getParentRoute: () => rootRouteImport,
} as any)
const AdminRouteRoute = AdminRouteRouteImport.update({
  id: '/admin',
  path: '/admin',
  getParentRoute: () => rootRouteImport,
} as any)
const IndexRoute = IndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => rootRouteImport,
} as any)
const OnboardingIndexRoute = OnboardingIndexRouteImport.update({
  id: '/onboarding/',
  path: '/onboarding/',
  getParentRoute: () => rootRouteImport,
} as any)
const VerifyCodeRoute = VerifyCodeRouteImport.update({
  id: '/verify/$code',
  path: '/verify/$code',
  getParentRoute: () => rootRouteImport,
} as any)
const OnboardingStudentRoute = OnboardingStudentRouteImport.update({
  id: '/onboarding/student',
  path: '/onboarding/student',
  getParentRoute: () => rootRouteImport,
} as any)
const OnboardingPartnerRoute = OnboardingPartnerRouteImport.update({
  id: '/onboarding/partner',
  path: '/onboarding/partner',
  getParentRoute: () => rootRouteImport,
} as any)
const AuthLogin2faRoute = AuthLogin2faRouteImport.update({
  id: '/auth/login-2fa',
  path: '/auth/login-2fa',
  getParentRoute: () => rootRouteImport,
} as any)
const StudentWorkLogsIndexRoute = StudentWorkLogsIndexRouteImport.update({
  id: '/work-logs/',
  path: '/work-logs/',
  getParentRoute: () => StudentRouteRoute,
} as any)
const StudentWalletIndexRoute = StudentWalletIndexRouteImport.update({
  id: '/wallet/',
  path: '/wallet/',
  getParentRoute: () => StudentRouteRoute,
} as any)
const StudentVerificationIndexRoute =
  StudentVerificationIndexRouteImport.update({
    id: '/verification/',
    path: '/verification/',
    getParentRoute: () => StudentRouteRoute,
  } as any)
const StudentTipsIndexRoute = StudentTipsIndexRouteImport.update({
  id: '/tips/',
  path: '/tips/',
  getParentRoute: () => StudentRouteRoute,
} as any)
const StudentSupportIndexRoute = StudentSupportIndexRouteImport.update({
  id: '/support/',
  path: '/support/',
  getParentRoute: () => StudentRouteRoute,
} as any)
const StudentSimulatedIndexRoute = StudentSimulatedIndexRouteImport.update({
  id: '/simulated/',
  path: '/simulated/',
  getParentRoute: () => StudentRouteRoute,
} as any)
const StudentReportsIndexRoute = StudentReportsIndexRouteImport.update({
  id: '/reports/',
  path: '/reports/',
  getParentRoute: () => StudentRouteRoute,
} as any)
const StudentProfileIndexRoute = StudentProfileIndexRouteImport.update({
  id: '/profile/',
  path: '/profile/',
  getParentRoute: () => StudentRouteRoute,
} as any)
const StudentPlacementIndexRoute = StudentPlacementIndexRouteImport.update({
  id: '/placement/',
  path: '/placement/',
  getParentRoute: () => StudentRouteRoute,
} as any)
const StudentPaymentsIndexRoute = StudentPaymentsIndexRouteImport.update({
  id: '/payments/',
  path: '/payments/',
  getParentRoute: () => StudentRouteRoute,
} as any)
const StudentNotificationsIndexRoute =
  StudentNotificationsIndexRouteImport.update({
    id: '/notifications/',
    path: '/notifications/',
    getParentRoute: () => StudentRouteRoute,
  } as any)
const StudentDashboardIndexRoute = StudentDashboardIndexRouteImport.update({
  id: '/dashboard/',
  path: '/dashboard/',
  getParentRoute: () => StudentRouteRoute,
} as any)
const StudentCvIndexRoute = StudentCvIndexRouteImport.update({
  id: '/cv/',
  path: '/cv/',
  getParentRoute: () => StudentRouteRoute,
} as any)
const StudentCoursesIndexRoute = StudentCoursesIndexRouteImport.update({
  id: '/courses/',
  path: '/courses/',
  getParentRoute: () => StudentRouteRoute,
} as any)
const StudentCertificatesIndexRoute =
  StudentCertificatesIndexRouteImport.update({
    id: '/certificates/',
    path: '/certificates/',
    getParentRoute: () => StudentRouteRoute,
  } as any)
const StudentBadgesIndexRoute = StudentBadgesIndexRouteImport.update({
  id: '/badges/',
  path: '/badges/',
  getParentRoute: () => StudentRouteRoute,
} as any)
const StudentAssessmentsIndexRoute = StudentAssessmentsIndexRouteImport.update({
  id: '/assessments/',
  path: '/assessments/',
  getParentRoute: () => StudentRouteRoute,
} as any)
const PartnerWorkLogsIndexRoute = PartnerWorkLogsIndexRouteImport.update({
  id: '/work-logs/',
  path: '/work-logs/',
  getParentRoute: () => PartnerRouteRoute,
} as any)
const PartnerVerificationIndexRoute =
  PartnerVerificationIndexRouteImport.update({
    id: '/verification/',
    path: '/verification/',
    getParentRoute: () => PartnerRouteRoute,
  } as any)
const PartnerTipsIndexRoute = PartnerTipsIndexRouteImport.update({
  id: '/tips/',
  path: '/tips/',
  getParentRoute: () => PartnerRouteRoute,
} as any)
const PartnerSupportIndexRoute = PartnerSupportIndexRouteImport.update({
  id: '/support/',
  path: '/support/',
  getParentRoute: () => PartnerRouteRoute,
} as any)
const PartnerStudentsIndexRoute = PartnerStudentsIndexRouteImport.update({
  id: '/students/',
  path: '/students/',
  getParentRoute: () => PartnerRouteRoute,
} as any)
const PartnerSlotsIndexRoute = PartnerSlotsIndexRouteImport.update({
  id: '/slots/',
  path: '/slots/',
  getParentRoute: () => PartnerRouteRoute,
} as any)
const PartnerRecommendationsIndexRoute =
  PartnerRecommendationsIndexRouteImport.update({
    id: '/recommendations/',
    path: '/recommendations/',
    getParentRoute: () => PartnerRouteRoute,
  } as any)
const PartnerProfileIndexRoute = PartnerProfileIndexRouteImport.update({
  id: '/profile/',
  path: '/profile/',
  getParentRoute: () => PartnerRouteRoute,
} as any)
const PartnerNotificationsIndexRoute =
  PartnerNotificationsIndexRouteImport.update({
    id: '/notifications/',
    path: '/notifications/',
    getParentRoute: () => PartnerRouteRoute,
  } as any)
const PartnerDashboardIndexRoute = PartnerDashboardIndexRouteImport.update({
  id: '/dashboard/',
  path: '/dashboard/',
  getParentRoute: () => PartnerRouteRoute,
} as any)
const PartnerAssessmentsIndexRoute = PartnerAssessmentsIndexRouteImport.update({
  id: '/assessments/',
  path: '/assessments/',
  getParentRoute: () => PartnerRouteRoute,
} as any)
const InstitutionDashboardIndexRoute =
  InstitutionDashboardIndexRouteImport.update({
    id: '/dashboard/',
    path: '/dashboard/',
    getParentRoute: () => InstitutionRouteRoute,
  } as any)
const AuthResetPasswordIndexRoute = AuthResetPasswordIndexRouteImport.update({
  id: '/auth/reset-password/',
  path: '/auth/reset-password/',
  getParentRoute: () => rootRouteImport,
} as any)
const AuthRegisterIndexRoute = AuthRegisterIndexRouteImport.update({
  id: '/auth/register/',
  path: '/auth/register/',
  getParentRoute: () => rootRouteImport,
} as any)
const AuthLoginIndexRoute = AuthLoginIndexRouteImport.update({
  id: '/auth/login/',
  path: '/auth/login/',
  getParentRoute: () => rootRouteImport,
} as any)
const AuthForgotPasswordIndexRoute = AuthForgotPasswordIndexRouteImport.update({
  id: '/auth/forgot-password/',
  path: '/auth/forgot-password/',
  getParentRoute: () => rootRouteImport,
} as any)
const AdminWorkLogsIndexRoute = AdminWorkLogsIndexRouteImport.update({
  id: '/work-logs/',
  path: '/work-logs/',
  getParentRoute: () => AdminRouteRoute,
} as any)
const AdminVerificationsIndexRoute = AdminVerificationsIndexRouteImport.update({
  id: '/verifications/',
  path: '/verifications/',
  getParentRoute: () => AdminRouteRoute,
} as any)
const AdminUsersIndexRoute = AdminUsersIndexRouteImport.update({
  id: '/users/',
  path: '/users/',
  getParentRoute: () => AdminRouteRoute,
} as any)
const AdminTrashIndexRoute = AdminTrashIndexRouteImport.update({
  id: '/trash/',
  path: '/trash/',
  getParentRoute: () => AdminRouteRoute,
} as any)
const AdminTipsIndexRoute = AdminTipsIndexRouteImport.update({
  id: '/tips/',
  path: '/tips/',
  getParentRoute: () => AdminRouteRoute,
} as any)
const AdminStudentsIndexRoute = AdminStudentsIndexRouteImport.update({
  id: '/students/',
  path: '/students/',
  getParentRoute: () => AdminRouteRoute,
} as any)
const AdminSettingsIndexRoute = AdminSettingsIndexRouteImport.update({
  id: '/settings/',
  path: '/settings/',
  getParentRoute: () => AdminRouteRoute,
} as any)
const AdminSessionsIndexRoute = AdminSessionsIndexRouteImport.update({
  id: '/sessions/',
  path: '/sessions/',
  getParentRoute: () => AdminRouteRoute,
} as any)
const AdminSeminarsIndexRoute = AdminSeminarsIndexRouteImport.update({
  id: '/seminars/',
  path: '/seminars/',
  getParentRoute: () => AdminRouteRoute,
} as any)
const AdminReportsIndexRoute = AdminReportsIndexRouteImport.update({
  id: '/reports/',
  path: '/reports/',
  getParentRoute: () => AdminRouteRoute,
} as any)
const AdminPlacementsIndexRoute = AdminPlacementsIndexRouteImport.update({
  id: '/placements/',
  path: '/placements/',
  getParentRoute: () => AdminRouteRoute,
} as any)
const AdminPaymentsIndexRoute = AdminPaymentsIndexRouteImport.update({
  id: '/payments/',
  path: '/payments/',
  getParentRoute: () => AdminRouteRoute,
} as any)
const AdminPartnersIndexRoute = AdminPartnersIndexRouteImport.update({
  id: '/partners/',
  path: '/partners/',
  getParentRoute: () => AdminRouteRoute,
} as any)
const AdminOnboardingIndexRoute = AdminOnboardingIndexRouteImport.update({
  id: '/onboarding/',
  path: '/onboarding/',
  getParentRoute: () => AdminRouteRoute,
} as any)
const AdminNotificationsIndexRoute = AdminNotificationsIndexRouteImport.update({
  id: '/notifications/',
  path: '/notifications/',
  getParentRoute: () => AdminRouteRoute,
} as any)
const AdminLeaderboardIndexRoute = AdminLeaderboardIndexRouteImport.update({
  id: '/leaderboard/',
  path: '/leaderboard/',
  getParentRoute: () => AdminRouteRoute,
} as any)
const AdminInstitutionsIndexRoute = AdminInstitutionsIndexRouteImport.update({
  id: '/institutions/',
  path: '/institutions/',
  getParentRoute: () => AdminRouteRoute,
} as any)
const AdminHelpSupportIndexRoute = AdminHelpSupportIndexRouteImport.update({
  id: '/help-support/',
  path: '/help-support/',
  getParentRoute: () => AdminRouteRoute,
} as any)
const AdminFeedbackIndexRoute = AdminFeedbackIndexRouteImport.update({
  id: '/feedback/',
  path: '/feedback/',
  getParentRoute: () => AdminRouteRoute,
} as any)
const AdminDashboardIndexRoute = AdminDashboardIndexRouteImport.update({
  id: '/dashboard/',
  path: '/dashboard/',
  getParentRoute: () => AdminRouteRoute,
} as any)
const AdminCoursesIndexRoute = AdminCoursesIndexRouteImport.update({
  id: '/courses/',
  path: '/courses/',
  getParentRoute: () => AdminRouteRoute,
} as any)
const AdminContentIndexRoute = AdminContentIndexRouteImport.update({
  id: '/content/',
  path: '/content/',
  getParentRoute: () => AdminRouteRoute,
} as any)
const AdminCertificatesIndexRoute = AdminCertificatesIndexRouteImport.update({
  id: '/certificates/',
  path: '/certificates/',
  getParentRoute: () => AdminRouteRoute,
} as any)
const AdminBadgesIndexRoute = AdminBadgesIndexRouteImport.update({
  id: '/badges/',
  path: '/badges/',
  getParentRoute: () => AdminRouteRoute,
} as any)
const AdminAuditLogsIndexRoute = AdminAuditLogsIndexRouteImport.update({
  id: '/audit-logs/',
  path: '/audit-logs/',
  getParentRoute: () => AdminRouteRoute,
} as any)
const StudentWorkLogsNewRoute = StudentWorkLogsNewRouteImport.update({
  id: '/work-logs/new',
  path: '/work-logs/new',
  getParentRoute: () => StudentRouteRoute,
} as any)
const StudentWorkLogsIdRoute = StudentWorkLogsIdRouteImport.update({
  id: '/work-logs/$id',
  path: '/work-logs/$id',
  getParentRoute: () => StudentRouteRoute,
} as any)
const PartnerWorkLogsIdRoute = PartnerWorkLogsIdRouteImport.update({
  id: '/work-logs/$id',
  path: '/work-logs/$id',
  getParentRoute: () => PartnerRouteRoute,
} as any)
const PartnerStudentsIdRoute = PartnerStudentsIdRouteImport.update({
  id: '/students/$id',
  path: '/students/$id',
  getParentRoute: () => PartnerRouteRoute,
} as any)
const PartnerSlotsNewRoute = PartnerSlotsNewRouteImport.update({
  id: '/slots/new',
  path: '/slots/new',
  getParentRoute: () => PartnerRouteRoute,
} as any)
const PartnerSlotsIdRoute = PartnerSlotsIdRouteImport.update({
  id: '/slots/$id',
  path: '/slots/$id',
  getParentRoute: () => PartnerRouteRoute,
} as any)
const PartnerRecommendationsNewRoute =
  PartnerRecommendationsNewRouteImport.update({
    id: '/recommendations/new',
    path: '/recommendations/new',
    getParentRoute: () => PartnerRouteRoute,
  } as any)
const AdminStudentsIdRoute = AdminStudentsIdRouteImport.update({
  id: '/students/$id',
  path: '/students/$id',
  getParentRoute: () => AdminRouteRoute,
} as any)
const AdminPlacementsAssignRoute = AdminPlacementsAssignRouteImport.update({
  id: '/placements/assign',
  path: '/placements/assign',
  getParentRoute: () => AdminRouteRoute,
} as any)
const AdminPartnersIdRoute = AdminPartnersIdRouteImport.update({
  id: '/partners/$id',
  path: '/partners/$id',
  getParentRoute: () => AdminRouteRoute,
} as any)
const AdminCoursesDiscoveryRoute = AdminCoursesDiscoveryRouteImport.update({
  id: '/courses/discovery',
  path: '/courses/discovery',
  getParentRoute: () => AdminRouteRoute,
} as any)
const StudentCoursesIdIndexRoute = StudentCoursesIdIndexRouteImport.update({
  id: '/courses/$id/',
  path: '/courses/$id/',
  getParentRoute: () => StudentRouteRoute,
} as any)
const StudentWorkLogsEditIdRoute = StudentWorkLogsEditIdRouteImport.update({
  id: '/work-logs/edit/$id',
  path: '/work-logs/edit/$id',
  getParentRoute: () => StudentRouteRoute,
} as any)
const StudentCoursesIdLearnRoute = StudentCoursesIdLearnRouteImport.update({
  id: '/courses/$id/learn',
  path: '/courses/$id/learn',
  getParentRoute: () => StudentRouteRoute,
} as any)

export interface FileRoutesByFullPath {
  '/': typeof IndexRoute
  '/admin': typeof AdminRouteRouteWithChildren
  '/institution': typeof InstitutionRouteRouteWithChildren
  '/partner': typeof PartnerRouteRouteWithChildren
  '/student': typeof StudentRouteRouteWithChildren
  '/contact': typeof ContactRoute
  '/auth/login-2fa': typeof AuthLogin2faRoute
  '/onboarding/partner': typeof OnboardingPartnerRoute
  '/onboarding/student': typeof OnboardingStudentRoute
  '/verify/$code': typeof VerifyCodeRoute
  '/onboarding/': typeof OnboardingIndexRoute
  '/admin/courses/discovery': typeof AdminCoursesDiscoveryRoute
  '/admin/partners/$id': typeof AdminPartnersIdRoute
  '/admin/placements/assign': typeof AdminPlacementsAssignRoute
  '/admin/students/$id': typeof AdminStudentsIdRoute
  '/partner/recommendations/new': typeof PartnerRecommendationsNewRoute
  '/partner/slots/$id': typeof PartnerSlotsIdRoute
  '/partner/slots/new': typeof PartnerSlotsNewRoute
  '/partner/students/$id': typeof PartnerStudentsIdRoute
  '/partner/work-logs/$id': typeof PartnerWorkLogsIdRoute
  '/student/work-logs/$id': typeof StudentWorkLogsIdRoute
  '/student/work-logs/new': typeof StudentWorkLogsNewRoute
  '/admin/audit-logs/': typeof AdminAuditLogsIndexRoute
  '/admin/badges/': typeof AdminBadgesIndexRoute
  '/admin/certificates/': typeof AdminCertificatesIndexRoute
  '/admin/content/': typeof AdminContentIndexRoute
  '/admin/courses/': typeof AdminCoursesIndexRoute
  '/admin/dashboard/': typeof AdminDashboardIndexRoute
  '/admin/feedback/': typeof AdminFeedbackIndexRoute
  '/admin/help-support/': typeof AdminHelpSupportIndexRoute
  '/admin/institutions/': typeof AdminInstitutionsIndexRoute
  '/admin/leaderboard/': typeof AdminLeaderboardIndexRoute
  '/admin/notifications/': typeof AdminNotificationsIndexRoute
  '/admin/onboarding/': typeof AdminOnboardingIndexRoute
  '/admin/partners/': typeof AdminPartnersIndexRoute
  '/admin/payments/': typeof AdminPaymentsIndexRoute
  '/admin/placements/': typeof AdminPlacementsIndexRoute
  '/admin/reports/': typeof AdminReportsIndexRoute
  '/admin/seminars/': typeof AdminSeminarsIndexRoute
  '/admin/sessions/': typeof AdminSessionsIndexRoute
  '/admin/settings/': typeof AdminSettingsIndexRoute
  '/admin/students/': typeof AdminStudentsIndexRoute
  '/admin/tips/': typeof AdminTipsIndexRoute
  '/admin/trash/': typeof AdminTrashIndexRoute
  '/admin/users/': typeof AdminUsersIndexRoute
  '/admin/verifications/': typeof AdminVerificationsIndexRoute
  '/admin/work-logs/': typeof AdminWorkLogsIndexRoute
  '/auth/forgot-password/': typeof AuthForgotPasswordIndexRoute
  '/auth/login/': typeof AuthLoginIndexRoute
  '/auth/register/': typeof AuthRegisterIndexRoute
  '/auth/reset-password/': typeof AuthResetPasswordIndexRoute
  '/institution/dashboard/': typeof InstitutionDashboardIndexRoute
  '/partner/assessments/': typeof PartnerAssessmentsIndexRoute
  '/partner/dashboard/': typeof PartnerDashboardIndexRoute
  '/partner/notifications/': typeof PartnerNotificationsIndexRoute
  '/partner/profile/': typeof PartnerProfileIndexRoute
  '/partner/recommendations/': typeof PartnerRecommendationsIndexRoute
  '/partner/slots/': typeof PartnerSlotsIndexRoute
  '/partner/students/': typeof PartnerStudentsIndexRoute
  '/partner/support/': typeof PartnerSupportIndexRoute
  '/partner/tips/': typeof PartnerTipsIndexRoute
  '/partner/verification/': typeof PartnerVerificationIndexRoute
  '/partner/work-logs/': typeof PartnerWorkLogsIndexRoute
  '/student/assessments/': typeof StudentAssessmentsIndexRoute
  '/student/badges/': typeof StudentBadgesIndexRoute
  '/student/certificates/': typeof StudentCertificatesIndexRoute
  '/student/courses/': typeof StudentCoursesIndexRoute
  '/student/cv/': typeof StudentCvIndexRoute
  '/student/dashboard/': typeof StudentDashboardIndexRoute
  '/student/notifications/': typeof StudentNotificationsIndexRoute
  '/student/payments/': typeof StudentPaymentsIndexRoute
  '/student/placement/': typeof StudentPlacementIndexRoute
  '/student/profile/': typeof StudentProfileIndexRoute
  '/student/reports/': typeof StudentReportsIndexRoute
  '/student/simulated/': typeof StudentSimulatedIndexRoute
  '/student/support/': typeof StudentSupportIndexRoute
  '/student/tips/': typeof StudentTipsIndexRoute
  '/student/verification/': typeof StudentVerificationIndexRoute
  '/student/wallet/': typeof StudentWalletIndexRoute
  '/student/work-logs/': typeof StudentWorkLogsIndexRoute
  '/student/courses/$id/learn': typeof StudentCoursesIdLearnRoute
  '/student/work-logs/edit/$id': typeof StudentWorkLogsEditIdRoute
  '/student/courses/$id/': typeof StudentCoursesIdIndexRoute
}
export interface FileRoutesByTo {
  '/': typeof IndexRoute
  '/admin': typeof AdminRouteRouteWithChildren
  '/institution': typeof InstitutionRouteRouteWithChildren
  '/partner': typeof PartnerRouteRouteWithChildren
  '/student': typeof StudentRouteRouteWithChildren
  '/contact': typeof ContactRoute
  '/auth/login-2fa': typeof AuthLogin2faRoute
  '/onboarding/partner': typeof OnboardingPartnerRoute
  '/onboarding/student': typeof OnboardingStudentRoute
  '/verify/$code': typeof VerifyCodeRoute
  '/onboarding': typeof OnboardingIndexRoute
  '/admin/courses/discovery': typeof AdminCoursesDiscoveryRoute
  '/admin/partners/$id': typeof AdminPartnersIdRoute
  '/admin/placements/assign': typeof AdminPlacementsAssignRoute
  '/admin/students/$id': typeof AdminStudentsIdRoute
  '/partner/recommendations/new': typeof PartnerRecommendationsNewRoute
  '/partner/slots/$id': typeof PartnerSlotsIdRoute
  '/partner/slots/new': typeof PartnerSlotsNewRoute
  '/partner/students/$id': typeof PartnerStudentsIdRoute
  '/partner/work-logs/$id': typeof PartnerWorkLogsIdRoute
  '/student/work-logs/$id': typeof StudentWorkLogsIdRoute
  '/student/work-logs/new': typeof StudentWorkLogsNewRoute
  '/admin/audit-logs': typeof AdminAuditLogsIndexRoute
  '/admin/badges': typeof AdminBadgesIndexRoute
  '/admin/certificates': typeof AdminCertificatesIndexRoute
  '/admin/content': typeof AdminContentIndexRoute
  '/admin/courses': typeof AdminCoursesIndexRoute
  '/admin/dashboard': typeof AdminDashboardIndexRoute
  '/admin/feedback': typeof AdminFeedbackIndexRoute
  '/admin/help-support': typeof AdminHelpSupportIndexRoute
  '/admin/institutions': typeof AdminInstitutionsIndexRoute
  '/admin/leaderboard': typeof AdminLeaderboardIndexRoute
  '/admin/notifications': typeof AdminNotificationsIndexRoute
  '/admin/onboarding': typeof AdminOnboardingIndexRoute
  '/admin/partners': typeof AdminPartnersIndexRoute
  '/admin/payments': typeof AdminPaymentsIndexRoute
  '/admin/placements': typeof AdminPlacementsIndexRoute
  '/admin/reports': typeof AdminReportsIndexRoute
  '/admin/seminars': typeof AdminSeminarsIndexRoute
  '/admin/sessions': typeof AdminSessionsIndexRoute
  '/admin/settings': typeof AdminSettingsIndexRoute
  '/admin/students': typeof AdminStudentsIndexRoute
  '/admin/tips': typeof AdminTipsIndexRoute
  '/admin/trash': typeof AdminTrashIndexRoute
  '/admin/users': typeof AdminUsersIndexRoute
  '/admin/verifications': typeof AdminVerificationsIndexRoute
  '/admin/work-logs': typeof AdminWorkLogsIndexRoute
  '/auth/forgot-password': typeof AuthForgotPasswordIndexRoute
  '/auth/login': typeof AuthLoginIndexRoute
  '/auth/register': typeof AuthRegisterIndexRoute
  '/auth/reset-password': typeof AuthResetPasswordIndexRoute
  '/institution/dashboard': typeof InstitutionDashboardIndexRoute
  '/partner/assessments': typeof PartnerAssessmentsIndexRoute
  '/partner/dashboard': typeof PartnerDashboardIndexRoute
  '/partner/notifications': typeof PartnerNotificationsIndexRoute
  '/partner/profile': typeof PartnerProfileIndexRoute
  '/partner/recommendations': typeof PartnerRecommendationsIndexRoute
  '/partner/slots': typeof PartnerSlotsIndexRoute
  '/partner/students': typeof PartnerStudentsIndexRoute
  '/partner/support': typeof PartnerSupportIndexRoute
  '/partner/tips': typeof PartnerTipsIndexRoute
  '/partner/verification': typeof PartnerVerificationIndexRoute
  '/partner/work-logs': typeof PartnerWorkLogsIndexRoute
  '/student/assessments': typeof StudentAssessmentsIndexRoute
  '/student/badges': typeof StudentBadgesIndexRoute
  '/student/certificates': typeof StudentCertificatesIndexRoute
  '/student/courses': typeof StudentCoursesIndexRoute
  '/student/cv': typeof StudentCvIndexRoute
  '/student/dashboard': typeof StudentDashboardIndexRoute
  '/student/notifications': typeof StudentNotificationsIndexRoute
  '/student/payments': typeof StudentPaymentsIndexRoute
  '/student/placement': typeof StudentPlacementIndexRoute
  '/student/profile': typeof StudentProfileIndexRoute
  '/student/reports': typeof StudentReportsIndexRoute
  '/student/simulated': typeof StudentSimulatedIndexRoute
  '/student/support': typeof StudentSupportIndexRoute
  '/student/tips': typeof StudentTipsIndexRoute
  '/student/verification': typeof StudentVerificationIndexRoute
  '/student/wallet': typeof StudentWalletIndexRoute
  '/student/work-logs': typeof StudentWorkLogsIndexRoute
  '/student/courses/$id/learn': typeof StudentCoursesIdLearnRoute
  '/student/work-logs/edit/$id': typeof StudentWorkLogsEditIdRoute
  '/student/courses/$id': typeof StudentCoursesIdIndexRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  '/': typeof IndexRoute
  '/admin': typeof AdminRouteRouteWithChildren
  '/institution': typeof InstitutionRouteRouteWithChildren
  '/partner': typeof PartnerRouteRouteWithChildren
  '/student': typeof StudentRouteRouteWithChildren
  '/contact': typeof ContactRoute
  '/auth/login-2fa': typeof AuthLogin2faRoute
  '/onboarding/partner': typeof OnboardingPartnerRoute
  '/onboarding/student': typeof OnboardingStudentRoute
  '/verify/$code': typeof VerifyCodeRoute
  '/onboarding/': typeof OnboardingIndexRoute
  '/admin/courses/discovery': typeof AdminCoursesDiscoveryRoute
  '/admin/partners/$id': typeof AdminPartnersIdRoute
  '/admin/placements/assign': typeof AdminPlacementsAssignRoute
  '/admin/students/$id': typeof AdminStudentsIdRoute
  '/partner/recommendations/new': typeof PartnerRecommendationsNewRoute
  '/partner/slots/$id': typeof PartnerSlotsIdRoute
  '/partner/slots/new': typeof PartnerSlotsNewRoute
  '/partner/students/$id': typeof PartnerStudentsIdRoute
  '/partner/work-logs/$id': typeof PartnerWorkLogsIdRoute
  '/student/work-logs/$id': typeof StudentWorkLogsIdRoute
  '/student/work-logs/new': typeof StudentWorkLogsNewRoute
  '/admin/audit-logs/': typeof AdminAuditLogsIndexRoute
  '/admin/badges/': typeof AdminBadgesIndexRoute
  '/admin/certificates/': typeof AdminCertificatesIndexRoute
  '/admin/content/': typeof AdminContentIndexRoute
  '/admin/courses/': typeof AdminCoursesIndexRoute
  '/admin/dashboard/': typeof AdminDashboardIndexRoute
  '/admin/feedback/': typeof AdminFeedbackIndexRoute
  '/admin/help-support/': typeof AdminHelpSupportIndexRoute
  '/admin/institutions/': typeof AdminInstitutionsIndexRoute
  '/admin/leaderboard/': typeof AdminLeaderboardIndexRoute
  '/admin/notifications/': typeof AdminNotificationsIndexRoute
  '/admin/onboarding/': typeof AdminOnboardingIndexRoute
  '/admin/partners/': typeof AdminPartnersIndexRoute
  '/admin/payments/': typeof AdminPaymentsIndexRoute
  '/admin/placements/': typeof AdminPlacementsIndexRoute
  '/admin/reports/': typeof AdminReportsIndexRoute
  '/admin/seminars/': typeof AdminSeminarsIndexRoute
  '/admin/sessions/': typeof AdminSessionsIndexRoute
  '/admin/settings/': typeof AdminSettingsIndexRoute
  '/admin/students/': typeof AdminStudentsIndexRoute
  '/admin/tips/': typeof AdminTipsIndexRoute
  '/admin/trash/': typeof AdminTrashIndexRoute
  '/admin/users/': typeof AdminUsersIndexRoute
  '/admin/verifications/': typeof AdminVerificationsIndexRoute
  '/admin/work-logs/': typeof AdminWorkLogsIndexRoute
  '/auth/forgot-password/': typeof AuthForgotPasswordIndexRoute
  '/auth/login/': typeof AuthLoginIndexRoute
  '/auth/register/': typeof AuthRegisterIndexRoute
  '/auth/reset-password/': typeof AuthResetPasswordIndexRoute
  '/institution/dashboard/': typeof InstitutionDashboardIndexRoute
  '/partner/assessments/': typeof PartnerAssessmentsIndexRoute
  '/partner/dashboard/': typeof PartnerDashboardIndexRoute
  '/partner/notifications/': typeof PartnerNotificationsIndexRoute
  '/partner/profile/': typeof PartnerProfileIndexRoute
  '/partner/recommendations/': typeof PartnerRecommendationsIndexRoute
  '/partner/slots/': typeof PartnerSlotsIndexRoute
  '/partner/students/': typeof PartnerStudentsIndexRoute
  '/partner/support/': typeof PartnerSupportIndexRoute
  '/partner/tips/': typeof PartnerTipsIndexRoute
  '/partner/verification/': typeof PartnerVerificationIndexRoute
  '/partner/work-logs/': typeof PartnerWorkLogsIndexRoute
  '/student/assessments/': typeof StudentAssessmentsIndexRoute
  '/student/badges/': typeof StudentBadgesIndexRoute
  '/student/certificates/': typeof StudentCertificatesIndexRoute
  '/student/courses/': typeof StudentCoursesIndexRoute
  '/student/cv/': typeof StudentCvIndexRoute
  '/student/dashboard/': typeof StudentDashboardIndexRoute
  '/student/notifications/': typeof StudentNotificationsIndexRoute
  '/student/payments/': typeof StudentPaymentsIndexRoute
  '/student/placement/': typeof StudentPlacementIndexRoute
  '/student/profile/': typeof StudentProfileIndexRoute
  '/student/reports/': typeof StudentReportsIndexRoute
  '/student/simulated/': typeof StudentSimulatedIndexRoute
  '/student/support/': typeof StudentSupportIndexRoute
  '/student/tips/': typeof StudentTipsIndexRoute
  '/student/verification/': typeof StudentVerificationIndexRoute
  '/student/wallet/': typeof StudentWalletIndexRoute
  '/student/work-logs/': typeof StudentWorkLogsIndexRoute
  '/student/courses/$id/learn': typeof StudentCoursesIdLearnRoute
  '/student/work-logs/edit/$id': typeof StudentWorkLogsEditIdRoute
  '/student/courses/$id/': typeof StudentCoursesIdIndexRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | '/'
    | '/admin'
    | '/institution'
    | '/partner'
    | '/student'
    | '/contact'
    | '/auth/login-2fa'
    | '/onboarding/partner'
    | '/onboarding/student'
    | '/verify/$code'
    | '/onboarding/'
    | '/admin/courses/discovery'
    | '/admin/partners/$id'
    | '/admin/placements/assign'
    | '/admin/students/$id'
    | '/partner/recommendations/new'
    | '/partner/slots/$id'
    | '/partner/slots/new'
    | '/partner/students/$id'
    | '/partner/work-logs/$id'
    | '/student/work-logs/$id'
    | '/student/work-logs/new'
    | '/admin/audit-logs/'
    | '/admin/badges/'
    | '/admin/certificates/'
    | '/admin/content/'
    | '/admin/courses/'
    | '/admin/dashboard/'
    | '/admin/feedback/'
    | '/admin/help-support/'
    | '/admin/institutions/'
    | '/admin/leaderboard/'
    | '/admin/notifications/'
    | '/admin/onboarding/'
    | '/admin/partners/'
    | '/admin/payments/'
    | '/admin/placements/'
    | '/admin/reports/'
    | '/admin/seminars/'
    | '/admin/sessions/'
    | '/admin/settings/'
    | '/admin/students/'
    | '/admin/tips/'
    | '/admin/trash/'
    | '/admin/users/'
    | '/admin/verifications/'
    | '/admin/work-logs/'
    | '/auth/forgot-password/'
    | '/auth/login/'
    | '/auth/register/'
    | '/auth/reset-password/'
    | '/institution/dashboard/'
    | '/partner/assessments/'
    | '/partner/dashboard/'
    | '/partner/notifications/'
    | '/partner/profile/'
    | '/partner/recommendations/'
    | '/partner/slots/'
    | '/partner/students/'
    | '/partner/support/'
    | '/partner/tips/'
    | '/partner/verification/'
    | '/partner/work-logs/'
    | '/student/assessments/'
    | '/student/badges/'
    | '/student/certificates/'
    | '/student/courses/'
    | '/student/cv/'
    | '/student/dashboard/'
    | '/student/notifications/'
    | '/student/payments/'
    | '/student/placement/'
    | '/student/profile/'
    | '/student/reports/'
    | '/student/simulated/'
    | '/student/support/'
    | '/student/tips/'
    | '/student/verification/'
    | '/student/wallet/'
    | '/student/work-logs/'
    | '/student/courses/$id/learn'
    | '/student/work-logs/edit/$id'
    | '/student/courses/$id/'
  fileRoutesByTo: FileRoutesByTo
  to:
    | '/'
    | '/admin'
    | '/institution'
    | '/partner'
    | '/student'
    | '/contact'
    | '/auth/login-2fa'
    | '/onboarding/partner'
    | '/onboarding/student'
    | '/verify/$code'
    | '/onboarding'
    | '/admin/courses/discovery'
    | '/admin/partners/$id'
    | '/admin/placements/assign'
    | '/admin/students/$id'
    | '/partner/recommendations/new'
    | '/partner/slots/$id'
    | '/partner/slots/new'
    | '/partner/students/$id'
    | '/partner/work-logs/$id'
    | '/student/work-logs/$id'
    | '/student/work-logs/new'
    | '/admin/audit-logs'
    | '/admin/badges'
    | '/admin/certificates'
    | '/admin/content'
    | '/admin/courses'
    | '/admin/dashboard'
    | '/admin/feedback'
    | '/admin/help-support'
    | '/admin/institutions'
    | '/admin/leaderboard'
    | '/admin/notifications'
    | '/admin/onboarding'
    | '/admin/partners'
    | '/admin/payments'
    | '/admin/placements'
    | '/admin/reports'
    | '/admin/seminars'
    | '/admin/sessions'
    | '/admin/settings'
    | '/admin/students'
    | '/admin/tips'
    | '/admin/trash'
    | '/admin/users'
    | '/admin/verifications'
    | '/admin/work-logs'
    | '/auth/forgot-password'
    | '/auth/login'
    | '/auth/register'
    | '/auth/reset-password'
    | '/institution/dashboard'
    | '/partner/assessments'
    | '/partner/dashboard'
    | '/partner/notifications'
    | '/partner/profile'
    | '/partner/recommendations'
    | '/partner/slots'
    | '/partner/students'
    | '/partner/support'
    | '/partner/tips'
    | '/partner/verification'
    | '/partner/work-logs'
    | '/student/assessments'
    | '/student/badges'
    | '/student/certificates'
    | '/student/courses'
    | '/student/cv'
    | '/student/dashboard'
    | '/student/notifications'
    | '/student/payments'
    | '/student/placement'
    | '/student/profile'
    | '/student/reports'
    | '/student/simulated'
    | '/student/support'
    | '/student/tips'
    | '/student/verification'
    | '/student/wallet'
    | '/student/work-logs'
    | '/student/courses/$id/learn'
    | '/student/work-logs/edit/$id'
    | '/student/courses/$id'
  id:
    | '__root__'
    | '/'
    | '/admin'
    | '/institution'
    | '/partner'
    | '/student'
    | '/contact'
    | '/auth/login-2fa'
    | '/onboarding/partner'
    | '/onboarding/student'
    | '/verify/$code'
    | '/onboarding/'
    | '/admin/courses/discovery'
    | '/admin/partners/$id'
    | '/admin/placements/assign'
    | '/admin/students/$id'
    | '/partner/recommendations/new'
    | '/partner/slots/$id'
    | '/partner/slots/new'
    | '/partner/students/$id'
    | '/partner/work-logs/$id'
    | '/student/work-logs/$id'
    | '/student/work-logs/new'
    | '/admin/audit-logs/'
    | '/admin/badges/'
    | '/admin/certificates/'
    | '/admin/content/'
    | '/admin/courses/'
    | '/admin/dashboard/'
    | '/admin/feedback/'
    | '/admin/help-support/'
    | '/admin/institutions/'
    | '/admin/leaderboard/'
    | '/admin/notifications/'
    | '/admin/onboarding/'
    | '/admin/partners/'
    | '/admin/payments/'
    | '/admin/placements/'
    | '/admin/reports/'
    | '/admin/seminars/'
    | '/admin/sessions/'
    | '/admin/settings/'
    | '/admin/students/'
    | '/admin/tips/'
    | '/admin/trash/'
    | '/admin/users/'
    | '/admin/verifications/'
    | '/admin/work-logs/'
    | '/auth/forgot-password/'
    | '/auth/login/'
    | '/auth/register/'
    | '/auth/reset-password/'
    | '/institution/dashboard/'
    | '/partner/assessments/'
    | '/partner/dashboard/'
    | '/partner/notifications/'
    | '/partner/profile/'
    | '/partner/recommendations/'
    | '/partner/slots/'
    | '/partner/students/'
    | '/partner/support/'
    | '/partner/tips/'
    | '/partner/verification/'
    | '/partner/work-logs/'
    | '/student/assessments/'
    | '/student/badges/'
    | '/student/certificates/'
    | '/student/courses/'
    | '/student/cv/'
    | '/student/dashboard/'
    | '/student/notifications/'
    | '/student/payments/'
    | '/student/placement/'
    | '/student/profile/'
    | '/student/reports/'
    | '/student/simulated/'
    | '/student/support/'
    | '/student/tips/'
    | '/student/verification/'
    | '/student/wallet/'
    | '/student/work-logs/'
    | '/student/courses/$id/learn'
    | '/student/work-logs/edit/$id'
    | '/student/courses/$id/'
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  IndexRoute: typeof IndexRoute
  AdminRouteRoute: typeof AdminRouteRouteWithChildren
  InstitutionRouteRoute: typeof InstitutionRouteRouteWithChildren
  PartnerRouteRoute: typeof PartnerRouteRouteWithChildren
  StudentRouteRoute: typeof StudentRouteRouteWithChildren
  ContactRoute: typeof ContactRoute
  AuthLogin2faRoute: typeof AuthLogin2faRoute
  OnboardingPartnerRoute: typeof OnboardingPartnerRoute
  OnboardingStudentRoute: typeof OnboardingStudentRoute
  VerifyCodeRoute: typeof VerifyCodeRoute
  OnboardingIndexRoute: typeof OnboardingIndexRoute
  AuthForgotPasswordIndexRoute: typeof AuthForgotPasswordIndexRoute
  AuthLoginIndexRoute: typeof AuthLoginIndexRoute
  AuthRegisterIndexRoute: typeof AuthRegisterIndexRoute
  AuthResetPasswordIndexRoute: typeof AuthResetPasswordIndexRoute
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/contact': {
      id: '/contact'
      path: '/contact'
      fullPath: '/contact'
      preLoaderRoute: typeof ContactRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/student': {
      id: '/student'
      path: '/student'
      fullPath: '/student'
      preLoaderRoute: typeof StudentRouteRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/partner': {
      id: '/partner'
      path: '/partner'
      fullPath: '/partner'
      preLoaderRoute: typeof PartnerRouteRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/institution': {
      id: '/institution'
      path: '/institution'
      fullPath: '/institution'
      preLoaderRoute: typeof InstitutionRouteRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/admin': {
      id: '/admin'
      path: '/admin'
      fullPath: '/admin'
      preLoaderRoute: typeof AdminRouteRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/': {
      id: '/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof IndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/onboarding/': {
      id: '/onboarding/'
      path: '/onboarding'
      fullPath: '/onboarding/'
      preLoaderRoute: typeof OnboardingIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/verify/$code': {
      id: '/verify/$code'
      path: '/verify/$code'
      fullPath: '/verify/$code'
      preLoaderRoute: typeof VerifyCodeRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/onboarding/student': {
      id: '/onboarding/student'
      path: '/onboarding/student'
      fullPath: '/onboarding/student'
      preLoaderRoute: typeof OnboardingStudentRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/onboarding/partner': {
      id: '/onboarding/partner'
      path: '/onboarding/partner'
      fullPath: '/onboarding/partner'
      preLoaderRoute: typeof OnboardingPartnerRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/auth/login-2fa': {
      id: '/auth/login-2fa'
      path: '/auth/login-2fa'
      fullPath: '/auth/login-2fa'
      preLoaderRoute: typeof AuthLogin2faRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/student/work-logs/': {
      id: '/student/work-logs/'
      path: '/work-logs'
      fullPath: '/student/work-logs/'
      preLoaderRoute: typeof StudentWorkLogsIndexRouteImport
      parentRoute: typeof StudentRouteRoute
    }
    '/student/wallet/': {
      id: '/student/wallet/'
      path: '/wallet'
      fullPath: '/student/wallet/'
      preLoaderRoute: typeof StudentWalletIndexRouteImport
      parentRoute: typeof StudentRouteRoute
    }
    '/student/verification/': {
      id: '/student/verification/'
      path: '/verification'
      fullPath: '/student/verification/'
      preLoaderRoute: typeof StudentVerificationIndexRouteImport
      parentRoute: typeof StudentRouteRoute
    }
    '/student/tips/': {
      id: '/student/tips/'
      path: '/tips'
      fullPath: '/student/tips/'
      preLoaderRoute: typeof StudentTipsIndexRouteImport
      parentRoute: typeof StudentRouteRoute
    }
    '/student/support/': {
      id: '/student/support/'
      path: '/support'
      fullPath: '/student/support/'
      preLoaderRoute: typeof StudentSupportIndexRouteImport
      parentRoute: typeof StudentRouteRoute
    }
    '/student/simulated/': {
      id: '/student/simulated/'
      path: '/simulated'
      fullPath: '/student/simulated/'
      preLoaderRoute: typeof StudentSimulatedIndexRouteImport
      parentRoute: typeof StudentRouteRoute
    }
    '/student/reports/': {
      id: '/student/reports/'
      path: '/reports'
      fullPath: '/student/reports/'
      preLoaderRoute: typeof StudentReportsIndexRouteImport
      parentRoute: typeof StudentRouteRoute
    }
    '/student/profile/': {
      id: '/student/profile/'
      path: '/profile'
      fullPath: '/student/profile/'
      preLoaderRoute: typeof StudentProfileIndexRouteImport
      parentRoute: typeof StudentRouteRoute
    }
    '/student/placement/': {
      id: '/student/placement/'
      path: '/placement'
      fullPath: '/student/placement/'
      preLoaderRoute: typeof StudentPlacementIndexRouteImport
      parentRoute: typeof StudentRouteRoute
    }
    '/student/payments/': {
      id: '/student/payments/'
      path: '/payments'
      fullPath: '/student/payments/'
      preLoaderRoute: typeof StudentPaymentsIndexRouteImport
      parentRoute: typeof StudentRouteRoute
    }
    '/student/notifications/': {
      id: '/student/notifications/'
      path: '/notifications'
      fullPath: '/student/notifications/'
      preLoaderRoute: typeof StudentNotificationsIndexRouteImport
      parentRoute: typeof StudentRouteRoute
    }
    '/student/dashboard/': {
      id: '/student/dashboard/'
      path: '/dashboard'
      fullPath: '/student/dashboard/'
      preLoaderRoute: typeof StudentDashboardIndexRouteImport
      parentRoute: typeof StudentRouteRoute
    }
    '/student/cv/': {
      id: '/student/cv/'
      path: '/cv'
      fullPath: '/student/cv/'
      preLoaderRoute: typeof StudentCvIndexRouteImport
      parentRoute: typeof StudentRouteRoute
    }
    '/student/courses/': {
      id: '/student/courses/'
      path: '/courses'
      fullPath: '/student/courses/'
      preLoaderRoute: typeof StudentCoursesIndexRouteImport
      parentRoute: typeof StudentRouteRoute
    }
    '/student/certificates/': {
      id: '/student/certificates/'
      path: '/certificates'
      fullPath: '/student/certificates/'
      preLoaderRoute: typeof StudentCertificatesIndexRouteImport
      parentRoute: typeof StudentRouteRoute
    }
    '/student/badges/': {
      id: '/student/badges/'
      path: '/badges'
      fullPath: '/student/badges/'
      preLoaderRoute: typeof StudentBadgesIndexRouteImport
      parentRoute: typeof StudentRouteRoute
    }
    '/student/assessments/': {
      id: '/student/assessments/'
      path: '/assessments'
      fullPath: '/student/assessments/'
      preLoaderRoute: typeof StudentAssessmentsIndexRouteImport
      parentRoute: typeof StudentRouteRoute
    }
    '/partner/work-logs/': {
      id: '/partner/work-logs/'
      path: '/work-logs'
      fullPath: '/partner/work-logs/'
      preLoaderRoute: typeof PartnerWorkLogsIndexRouteImport
      parentRoute: typeof PartnerRouteRoute
    }
    '/partner/verification/': {
      id: '/partner/verification/'
      path: '/verification'
      fullPath: '/partner/verification/'
      preLoaderRoute: typeof PartnerVerificationIndexRouteImport
      parentRoute: typeof PartnerRouteRoute
    }
    '/partner/tips/': {
      id: '/partner/tips/'
      path: '/tips'
      fullPath: '/partner/tips/'
      preLoaderRoute: typeof PartnerTipsIndexRouteImport
      parentRoute: typeof PartnerRouteRoute
    }
    '/partner/support/': {
      id: '/partner/support/'
      path: '/support'
      fullPath: '/partner/support/'
      preLoaderRoute: typeof PartnerSupportIndexRouteImport
      parentRoute: typeof PartnerRouteRoute
    }
    '/partner/students/': {
      id: '/partner/students/'
      path: '/students'
      fullPath: '/partner/students/'
      preLoaderRoute: typeof PartnerStudentsIndexRouteImport
      parentRoute: typeof PartnerRouteRoute
    }
    '/partner/slots/': {
      id: '/partner/slots/'
      path: '/slots'
      fullPath: '/partner/slots/'
      preLoaderRoute: typeof PartnerSlotsIndexRouteImport
      parentRoute: typeof PartnerRouteRoute
    }
    '/partner/recommendations/': {
      id: '/partner/recommendations/'
      path: '/recommendations'
      fullPath: '/partner/recommendations/'
      preLoaderRoute: typeof PartnerRecommendationsIndexRouteImport
      parentRoute: typeof PartnerRouteRoute
    }
    '/partner/profile/': {
      id: '/partner/profile/'
      path: '/profile'
      fullPath: '/partner/profile/'
      preLoaderRoute: typeof PartnerProfileIndexRouteImport
      parentRoute: typeof PartnerRouteRoute
    }
    '/partner/notifications/': {
      id: '/partner/notifications/'
      path: '/notifications'
      fullPath: '/partner/notifications/'
      preLoaderRoute: typeof PartnerNotificationsIndexRouteImport
      parentRoute: typeof PartnerRouteRoute
    }
    '/partner/dashboard/': {
      id: '/partner/dashboard/'
      path: '/dashboard'
      fullPath: '/partner/dashboard/'
      preLoaderRoute: typeof PartnerDashboardIndexRouteImport
      parentRoute: typeof PartnerRouteRoute
    }
    '/partner/assessments/': {
      id: '/partner/assessments/'
      path: '/assessments'
      fullPath: '/partner/assessments/'
      preLoaderRoute: typeof PartnerAssessmentsIndexRouteImport
      parentRoute: typeof PartnerRouteRoute
    }
    '/institution/dashboard/': {
      id: '/institution/dashboard/'
      path: '/dashboard'
      fullPath: '/institution/dashboard/'
      preLoaderRoute: typeof InstitutionDashboardIndexRouteImport
      parentRoute: typeof InstitutionRouteRoute
    }
    '/auth/reset-password/': {
      id: '/auth/reset-password/'
      path: '/auth/reset-password'
      fullPath: '/auth/reset-password/'
      preLoaderRoute: typeof AuthResetPasswordIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/auth/register/': {
      id: '/auth/register/'
      path: '/auth/register'
      fullPath: '/auth/register/'
      preLoaderRoute: typeof AuthRegisterIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/auth/login/': {
      id: '/auth/login/'
      path: '/auth/login'
      fullPath: '/auth/login/'
      preLoaderRoute: typeof AuthLoginIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/auth/forgot-password/': {
      id: '/auth/forgot-password/'
      path: '/auth/forgot-password'
      fullPath: '/auth/forgot-password/'
      preLoaderRoute: typeof AuthForgotPasswordIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/admin/work-logs/': {
      id: '/admin/work-logs/'
      path: '/work-logs'
      fullPath: '/admin/work-logs/'
      preLoaderRoute: typeof AdminWorkLogsIndexRouteImport
      parentRoute: typeof AdminRouteRoute
    }
    '/admin/verifications/': {
      id: '/admin/verifications/'
      path: '/verifications'
      fullPath: '/admin/verifications/'
      preLoaderRoute: typeof AdminVerificationsIndexRouteImport
      parentRoute: typeof AdminRouteRoute
    }
    '/admin/users/': {
      id: '/admin/users/'
      path: '/users'
      fullPath: '/admin/users/'
      preLoaderRoute: typeof AdminUsersIndexRouteImport
      parentRoute: typeof AdminRouteRoute
    }
    '/admin/trash/': {
      id: '/admin/trash/'
      path: '/trash'
      fullPath: '/admin/trash/'
      preLoaderRoute: typeof AdminTrashIndexRouteImport
      parentRoute: typeof AdminRouteRoute
    }
    '/admin/tips/': {
      id: '/admin/tips/'
      path: '/tips'
      fullPath: '/admin/tips/'
      preLoaderRoute: typeof AdminTipsIndexRouteImport
      parentRoute: typeof AdminRouteRoute
    }
    '/admin/students/': {
      id: '/admin/students/'
      path: '/students'
      fullPath: '/admin/students/'
      preLoaderRoute: typeof AdminStudentsIndexRouteImport
      parentRoute: typeof AdminRouteRoute
    }
    '/admin/settings/': {
      id: '/admin/settings/'
      path: '/settings'
      fullPath: '/admin/settings/'
      preLoaderRoute: typeof AdminSettingsIndexRouteImport
      parentRoute: typeof AdminRouteRoute
    }
    '/admin/sessions/': {
      id: '/admin/sessions/'
      path: '/sessions'
      fullPath: '/admin/sessions/'
      preLoaderRoute: typeof AdminSessionsIndexRouteImport
      parentRoute: typeof AdminRouteRoute
    }
    '/admin/seminars/': {
      id: '/admin/seminars/'
      path: '/seminars'
      fullPath: '/admin/seminars/'
      preLoaderRoute: typeof AdminSeminarsIndexRouteImport
      parentRoute: typeof AdminRouteRoute
    }
    '/admin/reports/': {
      id: '/admin/reports/'
      path: '/reports'
      fullPath: '/admin/reports/'
      preLoaderRoute: typeof AdminReportsIndexRouteImport
      parentRoute: typeof AdminRouteRoute
    }
    '/admin/placements/': {
      id: '/admin/placements/'
      path: '/placements'
      fullPath: '/admin/placements/'
      preLoaderRoute: typeof AdminPlacementsIndexRouteImport
      parentRoute: typeof AdminRouteRoute
    }
    '/admin/payments/': {
      id: '/admin/payments/'
      path: '/payments'
      fullPath: '/admin/payments/'
      preLoaderRoute: typeof AdminPaymentsIndexRouteImport
      parentRoute: typeof AdminRouteRoute
    }
    '/admin/partners/': {
      id: '/admin/partners/'
      path: '/partners'
      fullPath: '/admin/partners/'
      preLoaderRoute: typeof AdminPartnersIndexRouteImport
      parentRoute: typeof AdminRouteRoute
    }
    '/admin/onboarding/': {
      id: '/admin/onboarding/'
      path: '/onboarding'
      fullPath: '/admin/onboarding/'
      preLoaderRoute: typeof AdminOnboardingIndexRouteImport
      parentRoute: typeof AdminRouteRoute
    }
    '/admin/notifications/': {
      id: '/admin/notifications/'
      path: '/notifications'
      fullPath: '/admin/notifications/'
      preLoaderRoute: typeof AdminNotificationsIndexRouteImport
      parentRoute: typeof AdminRouteRoute
    }
    '/admin/leaderboard/': {
      id: '/admin/leaderboard/'
      path: '/leaderboard'
      fullPath: '/admin/leaderboard/'
      preLoaderRoute: typeof AdminLeaderboardIndexRouteImport
      parentRoute: typeof AdminRouteRoute
    }
    '/admin/institutions/': {
      id: '/admin/institutions/'
      path: '/institutions'
      fullPath: '/admin/institutions/'
      preLoaderRoute: typeof AdminInstitutionsIndexRouteImport
      parentRoute: typeof AdminRouteRoute
    }
    '/admin/help-support/': {
      id: '/admin/help-support/'
      path: '/help-support'
      fullPath: '/admin/help-support/'
      preLoaderRoute: typeof AdminHelpSupportIndexRouteImport
      parentRoute: typeof AdminRouteRoute
    }
    '/admin/feedback/': {
      id: '/admin/feedback/'
      path: '/feedback'
      fullPath: '/admin/feedback/'
      preLoaderRoute: typeof AdminFeedbackIndexRouteImport
      parentRoute: typeof AdminRouteRoute
    }
    '/admin/dashboard/': {
      id: '/admin/dashboard/'
      path: '/dashboard'
      fullPath: '/admin/dashboard/'
      preLoaderRoute: typeof AdminDashboardIndexRouteImport
      parentRoute: typeof AdminRouteRoute
    }
    '/admin/courses/': {
      id: '/admin/courses/'
      path: '/courses'
      fullPath: '/admin/courses/'
      preLoaderRoute: typeof AdminCoursesIndexRouteImport
      parentRoute: typeof AdminRouteRoute
    }
    '/admin/content/': {
      id: '/admin/content/'
      path: '/content'
      fullPath: '/admin/content/'
      preLoaderRoute: typeof AdminContentIndexRouteImport
      parentRoute: typeof AdminRouteRoute
    }
    '/admin/certificates/': {
      id: '/admin/certificates/'
      path: '/certificates'
      fullPath: '/admin/certificates/'
      preLoaderRoute: typeof AdminCertificatesIndexRouteImport
      parentRoute: typeof AdminRouteRoute
    }
    '/admin/badges/': {
      id: '/admin/badges/'
      path: '/badges'
      fullPath: '/admin/badges/'
      preLoaderRoute: typeof AdminBadgesIndexRouteImport
      parentRoute: typeof AdminRouteRoute
    }
    '/admin/audit-logs/': {
      id: '/admin/audit-logs/'
      path: '/audit-logs'
      fullPath: '/admin/audit-logs/'
      preLoaderRoute: typeof AdminAuditLogsIndexRouteImport
      parentRoute: typeof AdminRouteRoute
    }
    '/student/work-logs/new': {
      id: '/student/work-logs/new'
      path: '/work-logs/new'
      fullPath: '/student/work-logs/new'
      preLoaderRoute: typeof StudentWorkLogsNewRouteImport
      parentRoute: typeof StudentRouteRoute
    }
    '/student/work-logs/$id': {
      id: '/student/work-logs/$id'
      path: '/work-logs/$id'
      fullPath: '/student/work-logs/$id'
      preLoaderRoute: typeof StudentWorkLogsIdRouteImport
      parentRoute: typeof StudentRouteRoute
    }
    '/partner/work-logs/$id': {
      id: '/partner/work-logs/$id'
      path: '/work-logs/$id'
      fullPath: '/partner/work-logs/$id'
      preLoaderRoute: typeof PartnerWorkLogsIdRouteImport
      parentRoute: typeof PartnerRouteRoute
    }
    '/partner/students/$id': {
      id: '/partner/students/$id'
      path: '/students/$id'
      fullPath: '/partner/students/$id'
      preLoaderRoute: typeof PartnerStudentsIdRouteImport
      parentRoute: typeof PartnerRouteRoute
    }
    '/partner/slots/new': {
      id: '/partner/slots/new'
      path: '/slots/new'
      fullPath: '/partner/slots/new'
      preLoaderRoute: typeof PartnerSlotsNewRouteImport
      parentRoute: typeof PartnerRouteRoute
    }
    '/partner/slots/$id': {
      id: '/partner/slots/$id'
      path: '/slots/$id'
      fullPath: '/partner/slots/$id'
      preLoaderRoute: typeof PartnerSlotsIdRouteImport
      parentRoute: typeof PartnerRouteRoute
    }
    '/partner/recommendations/new': {
      id: '/partner/recommendations/new'
      path: '/recommendations/new'
      fullPath: '/partner/recommendations/new'
      preLoaderRoute: typeof PartnerRecommendationsNewRouteImport
      parentRoute: typeof PartnerRouteRoute
    }
    '/admin/students/$id': {
      id: '/admin/students/$id'
      path: '/students/$id'
      fullPath: '/admin/students/$id'
      preLoaderRoute: typeof AdminStudentsIdRouteImport
      parentRoute: typeof AdminRouteRoute
    }
    '/admin/placements/assign': {
      id: '/admin/placements/assign'
      path: '/placements/assign'
      fullPath: '/admin/placements/assign'
      preLoaderRoute: typeof AdminPlacementsAssignRouteImport
      parentRoute: typeof AdminRouteRoute
    }
    '/admin/partners/$id': {
      id: '/admin/partners/$id'
      path: '/partners/$id'
      fullPath: '/admin/partners/$id'
      preLoaderRoute: typeof AdminPartnersIdRouteImport
      parentRoute: typeof AdminRouteRoute
    }
    '/admin/courses/discovery': {
      id: '/admin/courses/discovery'
      path: '/courses/discovery'
      fullPath: '/admin/courses/discovery'
      preLoaderRoute: typeof AdminCoursesDiscoveryRouteImport
      parentRoute: typeof AdminRouteRoute
    }
    '/student/courses/$id/': {
      id: '/student/courses/$id/'
      path: '/courses/$id'
      fullPath: '/student/courses/$id/'
      preLoaderRoute: typeof StudentCoursesIdIndexRouteImport
      parentRoute: typeof StudentRouteRoute
    }
    '/student/work-logs/edit/$id': {
      id: '/student/work-logs/edit/$id'
      path: '/work-logs/edit/$id'
      fullPath: '/student/work-logs/edit/$id'
      preLoaderRoute: typeof StudentWorkLogsEditIdRouteImport
      parentRoute: typeof StudentRouteRoute
    }
    '/student/courses/$id/learn': {
      id: '/student/courses/$id/learn'
      path: '/courses/$id/learn'
      fullPath: '/student/courses/$id/learn'
      preLoaderRoute: typeof StudentCoursesIdLearnRouteImport
      parentRoute: typeof StudentRouteRoute
    }
  }
}

interface AdminRouteRouteChildren {
  AdminCoursesDiscoveryRoute: typeof AdminCoursesDiscoveryRoute
  AdminPartnersIdRoute: typeof AdminPartnersIdRoute
  AdminPlacementsAssignRoute: typeof AdminPlacementsAssignRoute
  AdminStudentsIdRoute: typeof AdminStudentsIdRoute
  AdminAuditLogsIndexRoute: typeof AdminAuditLogsIndexRoute
  AdminBadgesIndexRoute: typeof AdminBadgesIndexRoute
  AdminCertificatesIndexRoute: typeof AdminCertificatesIndexRoute
  AdminContentIndexRoute: typeof AdminContentIndexRoute
  AdminCoursesIndexRoute: typeof AdminCoursesIndexRoute
  AdminDashboardIndexRoute: typeof AdminDashboardIndexRoute
  AdminFeedbackIndexRoute: typeof AdminFeedbackIndexRoute
  AdminHelpSupportIndexRoute: typeof AdminHelpSupportIndexRoute
  AdminInstitutionsIndexRoute: typeof AdminInstitutionsIndexRoute
  AdminLeaderboardIndexRoute: typeof AdminLeaderboardIndexRoute
  AdminNotificationsIndexRoute: typeof AdminNotificationsIndexRoute
  AdminOnboardingIndexRoute: typeof AdminOnboardingIndexRoute
  AdminPartnersIndexRoute: typeof AdminPartnersIndexRoute
  AdminPaymentsIndexRoute: typeof AdminPaymentsIndexRoute
  AdminPlacementsIndexRoute: typeof AdminPlacementsIndexRoute
  AdminReportsIndexRoute: typeof AdminReportsIndexRoute
  AdminSeminarsIndexRoute: typeof AdminSeminarsIndexRoute
  AdminSessionsIndexRoute: typeof AdminSessionsIndexRoute
  AdminSettingsIndexRoute: typeof AdminSettingsIndexRoute
  AdminStudentsIndexRoute: typeof AdminStudentsIndexRoute
  AdminTipsIndexRoute: typeof AdminTipsIndexRoute
  AdminTrashIndexRoute: typeof AdminTrashIndexRoute
  AdminUsersIndexRoute: typeof AdminUsersIndexRoute
  AdminVerificationsIndexRoute: typeof AdminVerificationsIndexRoute
  AdminWorkLogsIndexRoute: typeof AdminWorkLogsIndexRoute
}

const AdminRouteRouteChildren: AdminRouteRouteChildren = {
  AdminCoursesDiscoveryRoute: AdminCoursesDiscoveryRoute,
  AdminPartnersIdRoute: AdminPartnersIdRoute,
  AdminPlacementsAssignRoute: AdminPlacementsAssignRoute,
  AdminStudentsIdRoute: AdminStudentsIdRoute,
  AdminAuditLogsIndexRoute: AdminAuditLogsIndexRoute,
  AdminBadgesIndexRoute: AdminBadgesIndexRoute,
  AdminCertificatesIndexRoute: AdminCertificatesIndexRoute,
  AdminContentIndexRoute: AdminContentIndexRoute,
  AdminCoursesIndexRoute: AdminCoursesIndexRoute,
  AdminDashboardIndexRoute: AdminDashboardIndexRoute,
  AdminFeedbackIndexRoute: AdminFeedbackIndexRoute,
  AdminHelpSupportIndexRoute: AdminHelpSupportIndexRoute,
  AdminInstitutionsIndexRoute: AdminInstitutionsIndexRoute,
  AdminLeaderboardIndexRoute: AdminLeaderboardIndexRoute,
  AdminNotificationsIndexRoute: AdminNotificationsIndexRoute,
  AdminOnboardingIndexRoute: AdminOnboardingIndexRoute,
  AdminPartnersIndexRoute: AdminPartnersIndexRoute,
  AdminPaymentsIndexRoute: AdminPaymentsIndexRoute,
  AdminPlacementsIndexRoute: AdminPlacementsIndexRoute,
  AdminReportsIndexRoute: AdminReportsIndexRoute,
  AdminSeminarsIndexRoute: AdminSeminarsIndexRoute,
  AdminSessionsIndexRoute: AdminSessionsIndexRoute,
  AdminSettingsIndexRoute: AdminSettingsIndexRoute,
  AdminStudentsIndexRoute: AdminStudentsIndexRoute,
  AdminTipsIndexRoute: AdminTipsIndexRoute,
  AdminTrashIndexRoute: AdminTrashIndexRoute,
  AdminUsersIndexRoute: AdminUsersIndexRoute,
  AdminVerificationsIndexRoute: AdminVerificationsIndexRoute,
  AdminWorkLogsIndexRoute: AdminWorkLogsIndexRoute,
}

const AdminRouteRouteWithChildren = AdminRouteRoute._addFileChildren(
  AdminRouteRouteChildren,
)

interface InstitutionRouteRouteChildren {
  InstitutionDashboardIndexRoute: typeof InstitutionDashboardIndexRoute
}

const InstitutionRouteRouteChildren: InstitutionRouteRouteChildren = {
  InstitutionDashboardIndexRoute: InstitutionDashboardIndexRoute,
}

const InstitutionRouteRouteWithChildren =
  InstitutionRouteRoute._addFileChildren(InstitutionRouteRouteChildren)

interface PartnerRouteRouteChildren {
  PartnerRecommendationsNewRoute: typeof PartnerRecommendationsNewRoute
  PartnerSlotsIdRoute: typeof PartnerSlotsIdRoute
  PartnerSlotsNewRoute: typeof PartnerSlotsNewRoute
  PartnerStudentsIdRoute: typeof PartnerStudentsIdRoute
  PartnerWorkLogsIdRoute: typeof PartnerWorkLogsIdRoute
  PartnerAssessmentsIndexRoute: typeof PartnerAssessmentsIndexRoute
  PartnerDashboardIndexRoute: typeof PartnerDashboardIndexRoute
  PartnerNotificationsIndexRoute: typeof PartnerNotificationsIndexRoute
  PartnerProfileIndexRoute: typeof PartnerProfileIndexRoute
  PartnerRecommendationsIndexRoute: typeof PartnerRecommendationsIndexRoute
  PartnerSlotsIndexRoute: typeof PartnerSlotsIndexRoute
  PartnerStudentsIndexRoute: typeof PartnerStudentsIndexRoute
  PartnerSupportIndexRoute: typeof PartnerSupportIndexRoute
  PartnerTipsIndexRoute: typeof PartnerTipsIndexRoute
  PartnerVerificationIndexRoute: typeof PartnerVerificationIndexRoute
  PartnerWorkLogsIndexRoute: typeof PartnerWorkLogsIndexRoute
}

const PartnerRouteRouteChildren: PartnerRouteRouteChildren = {
  PartnerRecommendationsNewRoute: PartnerRecommendationsNewRoute,
  PartnerSlotsIdRoute: PartnerSlotsIdRoute,
  PartnerSlotsNewRoute: PartnerSlotsNewRoute,
  PartnerStudentsIdRoute: PartnerStudentsIdRoute,
  PartnerWorkLogsIdRoute: PartnerWorkLogsIdRoute,
  PartnerAssessmentsIndexRoute: PartnerAssessmentsIndexRoute,
  PartnerDashboardIndexRoute: PartnerDashboardIndexRoute,
  PartnerNotificationsIndexRoute: PartnerNotificationsIndexRoute,
  PartnerProfileIndexRoute: PartnerProfileIndexRoute,
  PartnerRecommendationsIndexRoute: PartnerRecommendationsIndexRoute,
  PartnerSlotsIndexRoute: PartnerSlotsIndexRoute,
  PartnerStudentsIndexRoute: PartnerStudentsIndexRoute,
  PartnerSupportIndexRoute: PartnerSupportIndexRoute,
  PartnerTipsIndexRoute: PartnerTipsIndexRoute,
  PartnerVerificationIndexRoute: PartnerVerificationIndexRoute,
  PartnerWorkLogsIndexRoute: PartnerWorkLogsIndexRoute,
}

const PartnerRouteRouteWithChildren = PartnerRouteRoute._addFileChildren(
  PartnerRouteRouteChildren,
)

interface StudentRouteRouteChildren {
  StudentWorkLogsIdRoute: typeof StudentWorkLogsIdRoute
  StudentWorkLogsNewRoute: typeof StudentWorkLogsNewRoute
  StudentAssessmentsIndexRoute: typeof StudentAssessmentsIndexRoute
  StudentBadgesIndexRoute: typeof StudentBadgesIndexRoute
  StudentCertificatesIndexRoute: typeof StudentCertificatesIndexRoute
  StudentCoursesIndexRoute: typeof StudentCoursesIndexRoute
  StudentCvIndexRoute: typeof StudentCvIndexRoute
  StudentDashboardIndexRoute: typeof StudentDashboardIndexRoute
  StudentNotificationsIndexRoute: typeof StudentNotificationsIndexRoute
  StudentPaymentsIndexRoute: typeof StudentPaymentsIndexRoute
  StudentPlacementIndexRoute: typeof StudentPlacementIndexRoute
  StudentProfileIndexRoute: typeof StudentProfileIndexRoute
  StudentReportsIndexRoute: typeof StudentReportsIndexRoute
  StudentSimulatedIndexRoute: typeof StudentSimulatedIndexRoute
  StudentSupportIndexRoute: typeof StudentSupportIndexRoute
  StudentTipsIndexRoute: typeof StudentTipsIndexRoute
  StudentVerificationIndexRoute: typeof StudentVerificationIndexRoute
  StudentWalletIndexRoute: typeof StudentWalletIndexRoute
  StudentWorkLogsIndexRoute: typeof StudentWorkLogsIndexRoute
  StudentCoursesIdLearnRoute: typeof StudentCoursesIdLearnRoute
  StudentWorkLogsEditIdRoute: typeof StudentWorkLogsEditIdRoute
  StudentCoursesIdIndexRoute: typeof StudentCoursesIdIndexRoute
}

const StudentRouteRouteChildren: StudentRouteRouteChildren = {
  StudentWorkLogsIdRoute: StudentWorkLogsIdRoute,
  StudentWorkLogsNewRoute: StudentWorkLogsNewRoute,
  StudentAssessmentsIndexRoute: StudentAssessmentsIndexRoute,
  StudentBadgesIndexRoute: StudentBadgesIndexRoute,
  StudentCertificatesIndexRoute: StudentCertificatesIndexRoute,
  StudentCoursesIndexRoute: StudentCoursesIndexRoute,
  StudentCvIndexRoute: StudentCvIndexRoute,
  StudentDashboardIndexRoute: StudentDashboardIndexRoute,
  StudentNotificationsIndexRoute: StudentNotificationsIndexRoute,
  StudentPaymentsIndexRoute: StudentPaymentsIndexRoute,
  StudentPlacementIndexRoute: StudentPlacementIndexRoute,
  StudentProfileIndexRoute: StudentProfileIndexRoute,
  StudentReportsIndexRoute: StudentReportsIndexRoute,
  StudentSimulatedIndexRoute: StudentSimulatedIndexRoute,
  StudentSupportIndexRoute: StudentSupportIndexRoute,
  StudentTipsIndexRoute: StudentTipsIndexRoute,
  StudentVerificationIndexRoute: StudentVerificationIndexRoute,
  StudentWalletIndexRoute: StudentWalletIndexRoute,
  StudentWorkLogsIndexRoute: StudentWorkLogsIndexRoute,
  StudentCoursesIdLearnRoute: StudentCoursesIdLearnRoute,
  StudentWorkLogsEditIdRoute: StudentWorkLogsEditIdRoute,
  StudentCoursesIdIndexRoute: StudentCoursesIdIndexRoute,
}

const StudentRouteRouteWithChildren = StudentRouteRoute._addFileChildren(
  StudentRouteRouteChildren,
)

const rootRouteChildren: RootRouteChildren = {
  IndexRoute: IndexRoute,
  AdminRouteRoute: AdminRouteRouteWithChildren,
  InstitutionRouteRoute: InstitutionRouteRouteWithChildren,
  PartnerRouteRoute: PartnerRouteRouteWithChildren,
  StudentRouteRoute: StudentRouteRouteWithChildren,
  ContactRoute: ContactRoute,
  AuthLogin2faRoute: AuthLogin2faRoute,
  OnboardingPartnerRoute: OnboardingPartnerRoute,
  OnboardingStudentRoute: OnboardingStudentRoute,
  VerifyCodeRoute: VerifyCodeRoute,
  OnboardingIndexRoute: OnboardingIndexRoute,
  AuthForgotPasswordIndexRoute: AuthForgotPasswordIndexRoute,
  AuthLoginIndexRoute: AuthLoginIndexRoute,
  AuthRegisterIndexRoute: AuthRegisterIndexRoute,
  AuthResetPasswordIndexRoute: AuthResetPasswordIndexRoute,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
